/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import HotelSearchResultsV2 from './HotelSearchResultsV2';
import {
  hideHeaderMenu,
  showHeaderMenu,
} from '../../../shared/helper-utils/appUtils';

function HotelSearchResultsPage() {
  // useEffect(() => {
  //   hideHeaderMenu();
  //   return () => showHeaderMenu();
  // }, []);

  return (
    <section className="hotel-search-page-container">
      <HotelSearchResultsV2 />
    </section>
  );
}

export default HotelSearchResultsPage;
